import { createSlice } from "@reduxjs/toolkit";
import { current } from 'immer';

const initialState = {
  selectedUserActivity: 0,
  userActivities: [{}],
  defaultUserActivities: [{}],
  selectedComponent: {
    type: "slide",
    name: "container",
  },
  history: [],
  defaultSelectedActivity: {
    id: null,
    isSet: false,
  },
  isEditing: false,
  discardSaveModalActive: false,
  successModal: {
    active: false,
    message: '',
    isEdited: false
  },
  isVideo: false,
  videoVisible: false,
  preferenceActive: false,
  currentSlidePreference: {},
  defaultPreference: {
    timestamp: 0,
    dropdownId: 1
  },
  videoProgress: 0,
  videoDuration: 0,
  seekToDuration: 0,
  isVideoPlaying: false,
  preferenceEditing: false
};

// activity slice which the user is designing
const activity = createSlice({
  name: "activity",
  initialState,
  reducers: {
    addUserActivity: (state, { payload }) => {
      if (state.isVideo) {
        // state.userActivities = [...state.userActivities, { ...payload, }];
        let arr = [...state.userActivities, { ...payload, }];
        const removed = arr.filter(item => item.question_id.timestamp === -1);
        // result
        const filtered = [...arr].filter(item => item.question_id.timestamp !== -1).sort((a, b) => (a.question_id.timestamp > b.question_id.timestamp) ? 1 : ((b.question_id.timestamp > a.question_id.timestamp) ? -1 : 0))
        const result = [...filtered, ...removed]
        state.userActivities = result

        let arr2 = [...state.userActivities, { ...payload, }];
        const removed2 = arr2.filter(item => item.question_id.timestamp === -1);
        // result
        const filtered2 = [...arr2].filter(item => item.question_id.timestamp !== -1).sort((a, b) => (a.question_id.timestamp > b.question_id.timestamp) ? 1 : ((b.question_id.timestamp > a.question_id.timestamp) ? -1 : 0))
        const result2 = [...filtered2, ...removed2]
        state.defaultUserActivities = result2

      } else {
        state.userActivities = [...state.userActivities, { ...payload, }];
        state.defaultUserActivities = [...state.defaultUserActivities, { ...payload }];
      }
      state.selectedUserActivity = state.userActivities.length - 1;
    },
    updateUserActivityVideo: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ?
          {
            ...payload.activity,
            question_id: {
              ...payload.activity.question_id,
              ...userActivity.question_id
            }
          } : userActivity)),
        defaultUserActivities: state.userActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ?
          {
            ...payload.activity,
            question_id: {
              ...payload.activity.question_id,
              ...userActivity.question_id
            }
          } : userActivity)),
      };
    },
    updateActivityTimer: (state, { payload }) => {
      let updated = state.userActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ?
        {
          ...userActivity,
          question_id: {
            ...userActivity.question_id,
            timestamp: payload.timestamp
          }
        } : userActivity))
      updated.sort(function (a, b) {
        if (a.question_id.timestamp === -1 || b.question_id.timestamp === -1) {
          return 1;
        }
        if (a.question_id.timestamp < b.question_id.timestamp) {
          return -1;
        }
        if (a.question_id.timestamp > b.question_id.timestamp) {
          return 1;
        }
        return 0
      })
      return {
        ...state,
        userActivities: updated,
      }
    },
    toggleIsVideo: (state, { payload }) => {
      return {
        ...state,
        isVideo: payload.isVideo
      }
    },
    updateVideoDuration: (state, { payload }) => {
      return {
        ...state,
        videoDuration: payload.videoDuration
      }
    },
    updateVideoProgress: (state, { payload }) => {
      return {
        ...state,
        videoProgress: payload.videoProgress
      }
    },
    updateSeekToDuration: (state, { payload }) => {
      return {
        ...state,
        seekToDuration: payload.seekToDuration
      }
    },
    updateIsVideoPlaying: (state, { payload }) => {
      return {
        ...state,
        isVideoPlaying: payload.isVideoPlaying
      }
    },
    toggleVideoVisible: (state, { payload }) => {
      return {
        ...state,
        videoVisible: payload.videoVisible
      }
    },

    togglePreference: (state, { payload }) => {
      return {
        ...state,
        preferenceActive: payload.preferenceActive,
        defaultPreference: payload.defaultPreference ? payload.defaultPreference : state.defaultPreference,
        preferenceEditing: payload.preferenceEditing !== undefined ? payload.preferenceEditing : state.preferenceEditing
      }
    },
    setUserActivity: (state, { payload }) => {
      return {
        ...state,
        userActivities: payload.activities,
        defaultUserActivities: payload.defaultActivities,
      };
      // state.selectedUserActivity = state.userActivities.length - 1;
    },
    setDefaultSelectedActivity: (state, { payload }) => {
      state.defaultSelectedActivity = payload.defaultSelectedActivity;
    },
    updateIsEditing: (state, { payload }) => {
      state.isEditing = payload.isEditing;
    },
    removeUserActivity: (state, { payload }) => {
      state.userActivities = state.userActivities.filter((activity, idx) => idx !== payload.idx);
      state.defaultUserActivities = state.defaultUserActivities.filter((activity, idx) => idx !== payload.idx);
      if (state.selectedUserActivity > 0) {
        state.selectedUserActivity = state.selectedUserActivity - 1;
      }
    },
    duplicateUserActivity: (state, { payload }) => {
      state.userActivities = [...state.userActivities, { ...payload }];
      state.defaultUserActivities = [...state.defaultUserActivities, { ...payload }];
      state.selectedUserActivity = state.userActivities.length - 1;
    },
    updateUserActivity: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ? { ...payload.activity } : userActivity)),
        defaultUserActivities: state.defaultUserActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ? { ...payload.activity } : userActivity)),
      };
    },
    updateDiscardSaveModal: (state, { payload }) => {
      state.discardSaveModalActive = payload;
    },
    updatePaginationImg: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) => (idx === payload.selectedActivityIdx ? { ...userActivity, paginationImg: payload.img } : userActivity)),
      };
    },

    updateThumbnailImg: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              theme_id: {
                ...userActivity.theme_id,
                thumbnail: null,
                thumbnail_data: {
                  name: payload.name,
                  uri: payload.uri,
                },
              },
            }
            : userActivity
        ),
      };
    },
    selectUserActivity: (state, { payload }) => {
      state.selectedUserActivity = payload;
    },
    updateQuestion: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                question: payload.question,
              },
            }
            : userActivity
        ),
      };
    },
    updateMcqAnswer: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                mcqoption_set: userActivity.question_id.mcqoption_set.map((option) => {
                  return option.id === payload.optionId ? { ...option, option: payload.answer } : { ...option };
                }),
              },
            }
            : userActivity
        ),
      };
    },

    updateMtfQuestion: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                question: payload.question,
              },
            }
            : userActivity
        ),
      };
    },
    updateMtfOption: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchthefollowingoption_set: userActivity.question_id.matchthefollowingoption_set.map((option, index) =>
                  option.id === payload.selectedOptionIdx
                    ? {
                      ...option,
                      ...payload.updatedOption,
                    }
                    : option
                ),
              },
            }
            : userActivity
        ),
      };
    },
    addMtfOption: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchthefollowingoption_set: [...userActivity.question_id.matchthefollowingoption_set, { ...payload.newOption }],
              },
            }
            : userActivity
        ),
      };
    },
    removeMtfOption: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchthefollowingoption_set: userActivity.question_id.matchthefollowingoption_set.filter((option, index) => option.id !== payload.selectedOptionIdx),
              },
            }
            : userActivity
        ),
      };
    },

    selectLastActivity: (state, { payload }) => {
      return {
        ...state,
        selectedUserActivity: state.userActivities.length - 1,
      };
    },

    removeQuestionIdFromOptions: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                mcqoption_set: userActivity.question_id.mcqoption_set.map((option) => {
                  let tempOption = { ...option };
                  delete tempOption["question_id"];
                  return tempOption;
                }),
              },
            }
            : userActivity
        ),
      };
    },
    removeMtfQuestionIdFromOptions: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchthefollowingoption_set: userActivity.question_id.matchthefollowingoption_set.map((option) => {
                  let tempOption = { ...option };
                  delete tempOption["question_id"];
                  return tempOption;
                }),
              },
            }
            : userActivity
        ),
      };
    },
    removeFillUpsQuestionIdFromOptions: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                fillintheblankanswer_set: userActivity.question_id.fillintheblankanswer_set.map((option) => {
                  let tempOption = { ...option };
                  delete tempOption["question_id"];
                  return tempOption;
                }),
              },
            }
            : userActivity
        ),
      };
    },

    updateCorrectMcqAnswer: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                mcqoption_set: userActivity.question_id.mcqoption_set.map((option) => {
                  return option.id === payload.optionId ? { ...option, is_correct: payload.is_correct } : { ...option };
                }),
              },
            }
            : userActivity
        ),
      };
    },
    updateStyles: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              theme_id: {
                ...userActivity.theme_id,
                styles: {
                  ...userActivity.theme_id.styles,
                  styles: {
                    ...payload.style,
                  },
                },
              },
            }
            : userActivity
        ),
      };
    },
    updateSelectedComponentType: (state, { payload }) => {
      state.selectedComponent = payload;
    },
    updateImage: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                image_data: {
                  name: payload.name,
                  uri: payload.uri,
                },
                image: null,
              },
            }
            : userActivity
        ),
      };
    },
    updateMtfOptionImage: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchthefollowingoption_set: userActivity.question_id.matchthefollowingoption_set.map((option, index) =>
                  option.id === payload.selectedOptionId
                    ? {
                      ...option,
                      ...payload.updatedImageData,
                    }
                    : option
                ),

                l_image_data: {
                  name: payload.name,
                  uri: payload.uri,
                },
              },
            }
            : userActivity
        ),
      };
    },

    updateTrueandFalseAnswer: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                answer: payload.answer,
              },
            }
            : userActivity
        ),
      };
    },

    updateFillinTheBlanksQuestion: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                question: payload.question,
              },
            }
            : userActivity
        ),
      };
    },
    updateFillinTheBlanksMultipleAnswer: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                fillintheblankanswer_set: payload.submittedAnswers,
              },
            }
            : userActivity
        ),
      };
    },
    updateFillintheBlanksSingleAnswer: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                fillintheblankanswer_set: payload.answer,
              },
            }
            : userActivity
        ),
      };
    },

    updateContainerImage: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                background_image_data: {
                  name: payload.name,
                  uri: payload.uri,
                },
                background_image: null,
              },
            }
            : userActivity
        ),
      };
    },
    clearCanvas: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ? {} : userActivity)),
        defaultUserActivities: state.defaultUserActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ? {} : userActivity)),
      };
    },
    resetCanvas: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) => (idx === state.selectedUserActivity ? state.defaultUserActivities[state.selectedUserActivity] : userActivity)),
      };
    },
    updateTimer: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                timer: payload.timer,
              },
            }
            : userActivity
        ),
      };
    },
    addHistory: (state, { payload }) => {
      return {
        ...state,
        history: [...state.history, [...state.userActivities]],
      };
    },
    addHistoryImmediate: (state, { payload }) => {
      return {
        ...state,
        history: [...state.history, [...payload.history]],
      };
    },
    undoChange: (state, { payload }) => {
      return {
        ...state,
        userActivities: payload.history,
        history: state.history.filter((his, idx) => {
          return idx !== state.history.length - 1;
        }),
      };
    },

    // ~~~~~~~~~~~~> Games <~~~~~~~~~~~~
    updateCrosswordGrid: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                grid_size: payload.grid_size,
              },
            }
            : userActivity
        ),
      };
    },
    addNewWordCrossword: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                word_set: [...userActivity.question_id.word_set, payload.newWord],
              },
            }
            : userActivity
        ),
      };
    },
    removeWordCrossword: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                word_set: userActivity.question_id.word_set.filter((word) => word.id !== payload.wordId),
              },
            }
            : userActivity
        ),
      };
    },
    updateCrosswordDescription: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === payload.selectedActivityIdx
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                description: payload.description,
              },
            }
            : userActivity
        ),
      };
    },

    // Matching Pairs
    addMatchingPairsPair: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchingpair_set: [...userActivity.question_id.matchingpair_set, { ...payload.pair }],
              },
            }
            : userActivity
        ),
      };
    },
    removeMatchingPairsPair: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchingpair_set: userActivity.question_id.matchingpair_set.filter(option => {
                  return option.id !== payload.id
                })
              },
            }
            : userActivity
        ),
      };
    },
    updateMatchingPairsOption: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchingpair_set: userActivity.question_id.matchingpair_set.map((option, index) =>
                  option.id === payload.selectedOption
                    ? {
                      ...option,
                      ...payload.updatedOption,
                    }
                    : option
                ),
              },
            }
            : userActivity
        ),
      };
    },
    removeMatchingPairsOptionImage: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchingpair_set: userActivity.question_id.matchingpair_set.map((option, index) => {
                  let tempOption = { ...option };
                  if (tempOption.id === payload.selectedOption) {
                    delete tempOption[payload.image_data];
                    tempOption[payload.option] = "Text";
                    if (payload.option === 'l_option') {
                      tempOption.l_image = null
                      tempOption.l_image_url = null
                    }
                    if (payload.option === 'r_option') {
                      tempOption.r_image = null
                      tempOption.r_image_url = null
                    }
                  }
                  return tempOption;
                }),
              },
            }
            : userActivity
        ),
      };
    },
    setMatchingPairsFlip: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchingpair_set: userActivity.question_id.matchingpair_set.map((option, index) => {
                  return { ...option, l_flipped: false, r_flipped: false };
                }),
              },
            }
            : userActivity
        ),
      };
    },
    setMatchingPairsImageUrl: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchingpair_set: userActivity.question_id.matchingpair_set.map((option, index) =>
                  option.id === payload.id
                    ? {
                      ...option,
                      ...payload.image_url
                    }
                    : option
                ),
              },
            }
            : userActivity
        ),
      };
    },
    updateMatchingPairsFlip: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                matchingpair_set: userActivity.question_id.matchingpair_set.map((option, index) =>
                  option.id === payload.selectedOption
                    ? {
                      ...option,
                      l_flipped: payload.l_flipped,
                      r_flipped: payload.r_flipped,
                    }
                    : option
                ),
              },
            }
            : userActivity
        ),
      };
    },

    updateDescription: (state, { payload }) => {
      return {
        ...state,
        userActivities: state.userActivities.map((userActivity, idx) =>
          idx === state.selectedUserActivity
            ? {
              ...userActivity,
              question_id: {
                ...userActivity.question_id,
                description: payload.description,
              },
            }
            : userActivity
        ),
      };
    },

    updateSuccessModal: (state, { payload }) => {
      state.successModal = {
        ...state.successModal,
        ...payload
      };
    },
  },
});

export const {
  selectUserActivity,
  setDefaultSelectedActivity,
  updateIsEditing,
  addMtfOption,
  removeMtfOption,
  updateMtfQuestion,
  selectLastActivity,
  updateDiscardSaveModal,
  toggleIsVideo, togglePreference,
  toggleVideoVisible,
  addUserActivityVideo,
  updateUserActivityVideo,
  updateActivityTimer,

  updateMtfOption,
  updateMtfOptionImage,
  updateUserActivity,
  updatePaginationImg,
  updateThumbnailImg,
  removeQuestionIdFromOptions,
  removeMtfQuestionIdFromOptions,
  removeFillUpsQuestionIdFromOptions,
  addUserActivity,
  setUserActivity,
  removeUserActivity,
  duplicateUserActivity,
  updateMcqAnswer,
  updateCorrectMcqAnswer,
  updateQuestion,
  updateStyles,
  updateSelectedComponentType,
  updateImage,
  updateTrueandFalseAnswer,

  updateFillinTheBlanksQuestion,
  updateFillinTheBlanksMultipleAnswer,
  updateFillintheBlanksSingleAnswer,

  updateContainerImage,
  clearCanvas,
  resetCanvas,
  updateTimer,
  addHistoryImmediate,
  addHistory,
  undoChange,

  // Games Crossword
  updateCrosswordGrid,
  addNewWordCrossword,
  removeWordCrossword,
  updateCrosswordDescription,

  // Matching pair
  addMatchingPairsPair,
  removeMatchingPairsPair,
  updateMatchingPairsOption,
  removeMatchingPairsOptionImage,
  setMatchingPairsImageUrl,
  setMatchingPairsFlip,
  updateMatchingPairsFlip,
  updateDescription,
  updateSuccessModal,
  updateVideoDuration,
  updateVideoProgress,
  updateSeekToDuration,
  updateIsVideoPlaying
} = activity.actions;
export default activity.reducer;
